import fetchChecksums, { Checksum } from "@jnctn/api/app/fetchChecksums";
import { useAsyncResource } from "use-async-resource";
import { useAuthContext } from "../../contexts/AuthContextProvider";

export function useChecksums(): Array<Checksum> {
  const { accessToken } = useAuthContext();
  const [checksumsReader] = useAsyncResource(fetchChecksums, accessToken);
  return checksumsReader();
}
